import { mapProductTypeToProductCategory } from "@grandvisionhq/svc-tealium/utils";
import { mapProductToTealiumProperties } from "./map-product-to-tealium-properties.js";
const mapProductToTealiumViewProperties = (product, activeVariant) => {
  let brandModelCode;
  if ("brandModelCode" in activeVariant) {
    brandModelCode = activeVariant.brandModelCode;
  }
  return {
    id: "VirtualPage-View",
    Page_Type: "Pdp",
    Page_Section1: mapProductTypeToProductCategory(product.productType),
    Page_Section2: brandModelCode || "",
    Products: {
      [activeVariant.sku]: mapProductToTealiumProperties(product, activeVariant)
    }
  };
};
export {
  mapProductToTealiumViewProperties
};
//# sourceMappingURL=map-product-to-tealium-view-properties.js.map
